import { Image, Space } from 'antd';
import React from 'react';
import cn from 'classnames';
import { DownloadOutlined } from '@ant-design/icons';
import { BeDocument } from '../../../../types/chat';
import Helpers from '../../../../lib/helpers';

type Props = {
  images: BeDocument[];
  myMessage?: boolean;
};

const MessageImages = ({ images, myMessage }: Props) => {
  const [current, setCurrent] = React.useState(0);

  const onDownload = (index?: number, imgSrc?: string) => {
    let file = imgSrc
      ? images.find((img) => img.blobFileUrl === imgSrc)
      : undefined;

    if (
      !file &&
      typeof index === 'number' &&
      index >= 0 &&
      index < images.length
    ) {
      file = images[index];
    }

    if (!file) {
      file = images[current] || images[0];
    }

    if (file?.blobFileUrl) {
      Helpers.downloadImage(file.blobFileUrl, file.name);
    }
  };

  return (
    <div
      className={cn('flex flex-col gap-2 w-full', {
        'flex-row-reverse': myMessage,
      })}
      data-testid="chat-message-images"
    >
      <Image.PreviewGroup
        preview={{
          toolbarRender: (_originalNode, info) => {
            const activeIndex =
              typeof info?.current === 'number' ? info.current : current;
            const imgSrc = (info as { image?: { src?: string } })?.image?.src;
            return (
              <Space
                size={12}
                className="toolbar-wrapper"
                data-testid="chat-message-image-toolbar"
              >
                <DownloadOutlined
                  data-testid="chat-message-image-download-btn"
                  onClick={() => onDownload(activeIndex, imgSrc)}
                />
              </Space>
            );
          },
          onChange: (index) => {
            setCurrent(index);
          },
          onVisibleChange: (_visible, _prevVisible, currentIdx) => {
            if (typeof currentIdx === 'number') {
              setCurrent(currentIdx);
            }
          },
        }}
        data-testid="chat-message-image-preview-group"
      >
        {images?.map((oneImage, idx) => {
          return (
            <div
              className="flex items-center gap-2 max-w-full overflow-hidden rounded-lg border border-light-input-border/20 dark:border-dark-input-border/20"
              key={oneImage?.id || idx}
              data-testid="chat-message-image-item"
            >
              <Image
                alt="message image"
                width={'100%'}
                className="object-cover"
                height={150}
                src={oneImage?.blobFileUrl}
                data-testid="chat-message-image"
              />
            </div>
          );
        })}
      </Image.PreviewGroup>
    </div>
  );
};

export default MessageImages;

